import { useMutation } from 'react-query';
import { RouterInput, trpc } from '../../../../lib/trpc';
import { uploadToAws } from '../ContentInformation/uploadToAws';

export default function useUploadPropertyTemplateDocs() {
    return useMutation(
        async ({
            files,
            propertyId,
            documentType,
        }: {
            files: File[];
            propertyId: number;
            documentType?: RouterInput['TemplatesApi']['uploadPropertyTemplateDocument']['documentType'];
        }) => {
            const responses = files.map(async (file) => {
                const fileToSave = {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                };

                const response = await trpc.TemplatesApi.uploadPropertyTemplateDocument.mutate({
                    file: fileToSave,
                    propertyId,
                    documentType: documentType,
                });

                if (response) {
                    await uploadToAws({
                        preSingedUrl: response.preSingedUrl,
                        file,
                        cleanup: async () => {
                            await trpc.TemplatesApi.removePropertyTemplateDocument.mutate({
                                id: response.id,
                                propertyId,
                            });
                        },
                    });
                }
            });
            return await Promise.all(responses);
        },
    );
}
